import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import styles from './styles.module.scss';

interface CompanyTabsProps {
  activeTab: string;
  onTabChange?: (tab: string) => void;
}

const TABS = [
  { id: 'about', labelKey: 'companyPage.tabs.about' },
  { id: 'employees', labelKey: 'companyPage.tabs.employees' },
  { id: 'reviews', labelKey: 'companyPage.tabs.reviews' },
  { id: 'documents', labelKey: 'companyPage.tabs.documents' },
];

export default function CompanyTabs({ activeTab, onTabChange }: CompanyTabsProps) {
  const { t } = useTranslation();

  return (
    <div className={styles.tabs}>
      {TABS.map((tab) => (
        <button
          key={tab.id}
          className={cn(styles.tab, { [styles.tabActive]: activeTab === tab.id })}
          onClick={() => onTabChange?.(tab.id)}
        >
          {t(tab.labelKey)}
        </button>
      ))}
    </div>
  );
}
